import type { ComplianceProviderConfig, LLMProviderConfig, MediaProviderConfig, TTSProviderConfig } from '@/api/config'

export type TongyiModelOption = {
  label: string
  value: string
  expiresAt: string
  capability: string
}

export const DASHSCOPE_IMAGE_API_BASE = 'https://dashscope.aliyuncs.com/api/v1/services/aigc/text2image/image-synthesis'
export const DASHSCOPE_QWEN_IMAGE_API_BASE = 'https://dashscope.aliyuncs.com/api/v1/services/aigc/multimodal-generation/generation'
export const DASHSCOPE_VIDEO_API_BASE = 'https://dashscope.aliyuncs.com/api/v1/services/aigc/video-generation/video-synthesis'
export const VOLCENGINE_ARK_IMAGE_API_BASE = 'https://ark.cn-beijing.volces.com/api/v3/images/generations'
export const VOLCENGINE_ARK_VIDEO_API_BASE = 'https://ark.cn-beijing.volces.com/api/v3/contents/generations/tasks'
export const TONGYI_DEFAULT_IMAGE_MODEL = 'qwen-image-2.0-pro-2026-03-03'
export const TONGYI_DEFAULT_VIDEO_MODEL = 'wan2.7-t2v'
export const VOLCENGINE_DEFAULT_IMAGE_MODEL = 'doubao-seedream-5-0-260128'
export const VOLCENGINE_DEFAULT_VIDEO_MODEL = 'doubao-seedance-1-0-pro-250528'
export const FAL_DEFAULT_IMAGE_MODEL = 'fal-ai/flux-pro'

export const azureDefaultModels = {
  chat: 'gpt-4.1-mini',
  analysis: 'gpt-4.1',
  review: 'gpt-4.1-mini',
} as const

export const tongyiFreeModelOptions = [
  'qwen3.6-max-preview',
  'tongyi-xiaomi-analysis-pro',
  'qwen3.5-122b-a10b',
  'qwen3.5-flash',
  'qwen3.5-35b-a3b',
  'glm-5',
  'qwen3.5-27b',
  'tongyi-xiaomi-analysis-flash',
  'qwen3-vl-flash-2026-01-22',
  'kimi-k2.5',
  'qwen3.5-flash-2026-02-23',
  'qwen3.5-397b-a17b',
  'MiniMax-M2.5',
  'qwen-flash-character-2026-02-26',
  'qwen3-coder-next',
  'qwen-flash-character',
  'MiniMax-M2.1',
  'gui-plus-2026-02-26',
] as const

export const tongyiDefaultModels = {
  chat: 'qwen3.5-flash',
  analysis: 'tongyi-xiaomi-analysis-flash',
  review: 'tongyi-xiaomi-analysis-flash',
} as const

export const tongyiImageModelOptions: TongyiModelOption[] = [
  { label: 'qwen-image-plus-2026-01-09 · 文生图 · 到期 2026/04/10', value: 'qwen-image-plus-2026-01-09', expiresAt: '2026/04/10', capability: '文生图' },
  { label: 'qwen-image-edit-max · 图像编辑 · 到期 2026/04/17', value: 'qwen-image-edit-max', expiresAt: '2026/04/17', capability: '图像编辑' },
  { label: 'qwen-image-2.0-pro-2026-03-03 · 高质量文生图 · 到期 2026/06/02', value: 'qwen-image-2.0-pro-2026-03-03', expiresAt: '2026/06/02', capability: '高质量文生图' },
  { label: 'qwen-image-2.0-2026-03-03 · 通用文生图 · 到期 2026/06/02', value: 'qwen-image-2.0-2026-03-03', expiresAt: '2026/06/02', capability: '通用文生图' },
  { label: 'wan2.7-image-pro · WanX 2.7 Pro · 按账号开通', value: 'wan2.7-image-pro', expiresAt: '按账号开通', capability: '文生图 / 图像编辑 / 多图参考' },
  { label: 'wan2.7-image · WanX 2.7 标准版 · 按账号开通', value: 'wan2.7-image', expiresAt: '按账号开通', capability: '文生图 / 图像编辑 / 多图参考' },
]

export const falImageModelOptions: TongyiModelOption[] = [
  { label: 'fal Flux.1 Pro · 待接通', value: 'fal-ai/flux-pro', expiresAt: '待配置接口', capability: '高质量文生图' },
  { label: 'fal Flux.1 Dev · 待接通', value: 'fal-ai/flux-dev', expiresAt: '待配置接口', capability: '通用文生图' },
]

export const tongyiVideoModelOptions: TongyiModelOption[] = [
  { label: 'wan2.7-t2v · 文本生视频 · 到期 2026/09/30', value: 'wan2.7-t2v', expiresAt: '2026/09/30', capability: '文本生视频' },
  { label: 'wan2.7-r2v · 参考生视频 · 到期 2026/09/30', value: 'wan2.7-r2v', expiresAt: '2026/09/30', capability: '参考生视频' },
  { label: 'wan2.7-i2v · 图生视频 · 到期 2026/09/30', value: 'wan2.7-i2v', expiresAt: '2026/09/30', capability: '图生视频' },
  { label: 'pixverse/pixverse-v5.6-it2v · PixVerse V5.6 · 按账号开通', value: 'pixverse/pixverse-v5.6-it2v', expiresAt: '按账号开通', capability: '首帧图生视频' },
  { label: 'wan2.6-i2v-flash · 图生视频 · 到期待维护', value: 'wan2.6-i2v-flash', expiresAt: '待维护', capability: '图生视频' },
  { label: 'wan2.6-r2v-flash · 参考图视频 · 到期待维护', value: 'wan2.6-r2v-flash', expiresAt: '待维护', capability: '参考图视频' },
]

export const volcengineImageModelOptions: TongyiModelOption[] = [
  { label: 'Doubao-Seedream-5.0-lite · 默认图像生成', value: VOLCENGINE_DEFAULT_IMAGE_MODEL, expiresAt: '按账号开通', capability: '文生图 / 参考图生成' },
  { label: 'Doubao-Seedream-4.0 · 按账号开通', value: 'doubao-seedream-4-0-250828', expiresAt: '按账号开通', capability: '文生图 / 图生图 / 组图生成' },
]

export const volcengineVideoModelOptions: TongyiModelOption[] = [
  { label: 'Doubao-Seedance-1.0-pro · 默认视频生成', value: VOLCENGINE_DEFAULT_VIDEO_MODEL, expiresAt: '按账号开通', capability: '文生视频 / 首帧生视频' },
  { label: 'Doubao-Seedance-2.0 · 按账号开通', value: 'doubao-seedance-2-0-260128音画同生', expiresAt: '按账号开通', capability: '文生视频 / 图生视频 / 多模态生视频' },
  { label: 'Kling 3.0 · 按接入点配置', value: 'kling-3.0', expiresAt: '按账号开通', capability: '文生视频 / 图生视频' },
  { label: 'Kling V2 · 按接入点配置', value: 'kling-v2', expiresAt: '按账号开通', capability: '文生视频 / 图生视频' },
]

export function resolveDashscopeImageApiBase(model: string) {
  const normalized = model.trim().toLowerCase()
  return normalized.startsWith('qwen-image') || normalized.startsWith('wan2.7-image')
    ? DASHSCOPE_QWEN_IMAGE_API_BASE
    : DASHSCOPE_IMAGE_API_BASE
}

export function buildModelQueuePreview(options: TongyiModelOption[], priorityModels: string[], defaultModel: string) {
  const source = priorityModels.length ? priorityModels : defaultModel && defaultModel !== 'default' ? [defaultModel] : []
  return source.map((value, index) => {
    const matched = options.find((item) => item.value === value)
    return {
      value,
      priority: index + 1,
      expiresAt: matched?.expiresAt || '未维护',
      capability: matched?.capability || '自定义模型',
    }
  })
}

export function clonePriorityModels(value: unknown) {
  return Array.isArray(value) ? value.map((item) => String(item || '').trim()).filter(Boolean) : []
}

export function sanitizeTongyiModel(model: string, purpose: keyof typeof tongyiDefaultModels) {
  return tongyiFreeModelOptions.includes(model as (typeof tongyiFreeModelOptions)[number])
    ? model
    : tongyiDefaultModels[purpose]
}

export function normalizeLLMProviderConfig(provider: string, config?: Partial<LLMProviderConfig>): LLMProviderConfig {
  const normalizedProvider = String(provider || '').trim()
  const normalized: LLMProviderConfig = {
    api_base: String(config?.api_base || '').trim(),
    api_key: String(config?.api_key || '').trim(),
    model_chat: String(config?.model_chat || '').trim(),
    model_analysis: String(config?.model_analysis || '').trim(),
    model_review: String(config?.model_review || '').trim(),
  }

  if (normalizedProvider === 'ali_tongyi') {
    normalized.api_base = normalized.api_base || 'https://dashscope.aliyuncs.com/compatible-mode/v1'
    normalized.model_chat = sanitizeTongyiModel(String(normalized.model_chat || ''), 'chat')
    normalized.model_analysis = sanitizeTongyiModel(String(normalized.model_analysis || ''), 'analysis')
    normalized.model_review = sanitizeTongyiModel(String(normalized.model_review || ''), 'review')
  }

  if (normalizedProvider === 'openai') {
    normalized.api_base = normalized.api_base || 'https://api.openai.com/v1'
  }

  if (normalizedProvider === 'azure') {
    normalized.model_chat = normalized.model_chat || azureDefaultModels.chat
    normalized.model_analysis = normalized.model_analysis || azureDefaultModels.analysis
    normalized.model_review = normalized.model_review || azureDefaultModels.review
  }

  if (normalizedProvider === 'gemini') {
    normalized.api_base = normalized.api_base || 'https://generativelanguage.googleapis.com/v1beta'
  }

  if (normalizedProvider === 'volcengine') {
    normalized.api_base = normalized.api_base || 'https://ark.cn-beijing.volces.com/api/v3'
  }

  return normalized
}

export function normalizeImageProviderConfig(
  provider: string,
  config: Partial<MediaProviderConfig> | undefined,
  shared: { llmApiKey: string },
): MediaProviderConfig {
  const normalizedProvider = String(provider || '').trim()
  if (normalizedProvider === 'ali_tongyi') {
    const priorityModels = clonePriorityModels(config?.priority_models)
    const model = String(config?.model || priorityModels[0] || TONGYI_DEFAULT_IMAGE_MODEL).trim() || TONGYI_DEFAULT_IMAGE_MODEL
    return {
      api_base: String(config?.api_base || resolveDashscopeImageApiBase(model)).trim() || resolveDashscopeImageApiBase(model),
      api_key: String(config?.api_key || shared.llmApiKey || '').trim(),
      api_secret: String(config?.api_secret || '').trim(),
      model,
      priority_models: priorityModels,
    }
  }

  if (normalizedProvider === 'volcengine') {
    return {
      api_base: String(config?.api_base || VOLCENGINE_ARK_IMAGE_API_BASE).trim() || VOLCENGINE_ARK_IMAGE_API_BASE,
      api_key: String(config?.api_key || shared.llmApiKey || '').trim(),
      api_secret: String(config?.api_secret || '').trim(),
      model: String(config?.model || VOLCENGINE_DEFAULT_IMAGE_MODEL).trim() || VOLCENGINE_DEFAULT_IMAGE_MODEL,
      priority_models: [],
    }
  }

  if (normalizedProvider === 'fal') {
    return {
      api_base: String(config?.api_base || '').trim(),
      api_key: String(config?.api_key || '').trim(),
      api_secret: String(config?.api_secret || '').trim(),
      model: String(config?.model || FAL_DEFAULT_IMAGE_MODEL).trim() || FAL_DEFAULT_IMAGE_MODEL,
      priority_models: [],
    }
  }

  return {
    api_base: String(config?.api_base || '').trim(),
    api_key: String(config?.api_key || '').trim(),
    api_secret: String(config?.api_secret || '').trim(),
    model: String(config?.model || '').trim(),
    priority_models: clonePriorityModels(config?.priority_models),
  }
}

export function normalizeVideoProviderConfig(
  provider: string,
  config: Partial<MediaProviderConfig> | undefined,
  shared: { llmApiKey: string },
): MediaProviderConfig {
  const normalizedProvider = String(provider || '').trim()
  if (normalizedProvider === 'ali_tongyi') {
    const priorityModels = clonePriorityModels(config?.priority_models)
    const model = String(config?.model || priorityModels[0] || TONGYI_DEFAULT_VIDEO_MODEL).trim() || TONGYI_DEFAULT_VIDEO_MODEL
    return {
      api_base: String(config?.api_base || DASHSCOPE_VIDEO_API_BASE).trim() || DASHSCOPE_VIDEO_API_BASE,
      api_key: String(config?.api_key || shared.llmApiKey || '').trim(),
      api_secret: String(config?.api_secret || '').trim(),
      model,
      priority_models: priorityModels,
    }
  }

  if (normalizedProvider === 'volcengine') {
    return {
      api_base: String(config?.api_base || VOLCENGINE_ARK_VIDEO_API_BASE).trim() || VOLCENGINE_ARK_VIDEO_API_BASE,
      api_key: String(config?.api_key || shared.llmApiKey || '').trim(),
      api_secret: String(config?.api_secret || '').trim(),
      model: String(config?.model || VOLCENGINE_DEFAULT_VIDEO_MODEL).trim() || VOLCENGINE_DEFAULT_VIDEO_MODEL,
      priority_models: [],
    }
  }

  return {
    api_base: String(config?.api_base || '').trim(),
    api_key: String(config?.api_key || '').trim(),
    api_secret: String(config?.api_secret || '').trim(),
    model: String(config?.model || '').trim(),
    priority_models: clonePriorityModels(config?.priority_models),
  }
}

export function normalizeComplianceProviderConfig(
  provider: string,
  config?: Partial<ComplianceProviderConfig>,
): ComplianceProviderConfig {
  const normalizedProvider = String(provider || '').trim()
  if (normalizedProvider === 'aliyun') {
    return {
      api_base: String(config?.api_base || 'https://green.aliyuncs.com').trim(),
      api_key: String(config?.api_key || '').trim(),
      secret: String(config?.secret || '').trim(),
      model: String(config?.model || 'default').trim() || 'default',
    }
  }

  return {
    api_base: String(config?.api_base || '').trim(),
    api_key: String(config?.api_key || '').trim(),
    secret: String(config?.secret || '').trim(),
    model: String(config?.model || '').trim(),
  }
}

export function normalizeTtsProviderConfig(
  provider: string,
  config?: Partial<TTSProviderConfig>,
): TTSProviderConfig {
  const normalizedProvider = String(provider || '').trim()
  const normalized: TTSProviderConfig = {
    api_base: String(config?.api_base || '').trim(),
    api_key: String(config?.api_key || '').trim(),
    api_secret: String(config?.api_secret || '').trim(),
    app_key: String(config?.app_key || '').trim(),
    region: String(config?.region || '').trim(),
    voice_id: String(config?.voice_id || '').trim(),
    model: String(config?.model || '').trim(),
  }

  if (normalizedProvider === 'aliyun') {
    normalized.region = normalized.region || 'cn-shanghai'
    normalized.voice_id = normalized.voice_id || 'xiaoyun'
    normalized.model = normalized.model || 'default'
  }

  if (normalizedProvider === 'volcengine') {
    normalized.region = normalized.region || 'volcano_tts'
    normalized.voice_id = normalized.voice_id || 'BV001_streaming'
    normalized.model = normalized.model || 'volcano_tts'
  }

  if (normalizedProvider === 'azure') {
    normalized.region = normalized.region || 'eastasia'
    normalized.voice_id = normalized.voice_id || 'zh-CN-XiaoxiaoNeural'
    normalized.model = normalized.model || 'default'
  }

  return normalized
}